<template>
  <b-modal id="devServerModal" title="Dev-сервер" ok-only size="lg" @ok="iKnowThatItIsDev">
    <h5>Внимание!</h5>
    <div>Вы находитесь на сервере для <strong>разработчиков!</strong></div>
    <a :href="mainPath">Переход на основной сервер</a>
  </b-modal>
</template>

<script>
export default {
  name: 'DevServerModal',
  data() {
    return {
      mainPath: 'https://gazprom-classes.etu.ru/',
      devPath: 'https://dev.gazprom-classes.etu.ru/',
      storageKey: 'iKnowThatItIsGPKDev'
    }
  },
  mounted() {
    if (document.location.href.includes(this.devPath)) {
      const iKnow = window.sessionStorage.getItem(this.storageKey)
      if (!iKnow || JSON.parse(iKnow).ok !== true) {
        this.$bvModal.show('devServerModal')
      }
    }
  },
  methods: {
    iKnowThatItIsDev() {
      window.sessionStorage.setItem(
        this.storageKey,
        JSON.stringify({ ok: true }),
      )
    }

  }
}
</script>

<style scoped>

</style>
